import { render, staticRenderFns } from "./PatientScans.vue?vue&type=template&id=c8346b0a&scoped=true&"
import script from "./PatientScans.vue?vue&type=script&lang=js&"
export * from "./PatientScans.vue?vue&type=script&lang=js&"
import style0 from "./PatientScans.vue?vue&type=style&index=0&id=c8346b0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8346b0a",
  null
  
)

export default component.exports